// extracted by mini-css-extract-plugin
var _1 = "root___nq1C_";
var _2 = "rootDefault___n8xph";
var _3 = "rootSmall___qGwD1";
export { _1 as "root", _2 as "rootDefault", _3 as "rootSmall" }
